export default __webpack_public_path__ + "static/media/about-6.7094f2e2.png";